export function getType(func): string {
    if (!_.isFunction(func)) {
        func = func.constructor;
    }

    if (func.name) {
        return func.name;
    }

    return (func + '').split(/\s|\(/)[1];
}

export default { getType }